import { define } from '../../define.js';
import { ButtonGroup } from './button-group.js';
export * from './button-group.js';
define('button-group', ButtonGroup);
